var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout-content"},[_c('div',{staticClass:"layout-banner-video"},[_c('AutoPlayVideo',{attrs:{"src":_vm.videoSrc,"height":"451px"}})],1),_c('div',{staticClass:"layout-overlay-image"},[_c('h1',{staticClass:"layout-banner-title"},[_vm._v(_vm._s(_vm.layoutBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }